import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedCat = categories.find((c) => c.key === selected);

  return (
    <div ref={ref} className="relative w-full max-w-xl">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 text-left transition-colors hover:border-primary-300"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-apps-2-line text-lg text-primary-500"></i>
          {selectedCat ? t(`cat_${selectedCat.key}`) : t('dropdown_placeholder')}
        </span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-40 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => {
                setSelected(cat.key);
                setOpen(false);
              }}
              className="flex items-center justify-between gap-2 whitespace-nowrap px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center overflow-hidden rounded-md">
                  <img src={cat.image} alt={t(`cat_${cat.key}`)} className="h-full w-full object-cover object-top" />
                </span>
                {t(`cat_${cat.key}`)}
              </span>
              <i className="ri-external-link-line text-foreground-400"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}